import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CommonDropdown from '@components/commonFilters/CommonDropdown';

import { setFilters } from '@store/common/action';
import { getFabricTypes as fetchFabricTypes } from '@store/design/action';
import { getAllFabricTypes, getCommonFilters } from '@store/reducers';

const FabricCategory = ({ type = 'FILTER', onSelectCallBack, isClearAll, onResetClearValue }) => {
	const [selectedItem, setSelectedItem] = useState('');
	const [isUpdated, setIsUpdated] = useState(true);
	const dispatch = useDispatch();
	let allFabricTypes = useSelector(getAllFabricTypes);
	const commonfilters = useSelector(getCommonFilters);

	allFabricTypes = allFabricTypes?.map((item) => {
		return {
			id: item.code,
			name: item.value
		};
	});

	useEffect(() => {
		dispatch(fetchFabricTypes());
	}, []);

	useEffect(() => {
		if (isClearAll) {
			setSelectedItem('');
			setIsUpdated(false);
			setTimeout(() => {
				setIsUpdated(true);
			}, 0);
		}
	}, [isClearAll]);

	const onSelectFabric = (value) => {
		setSelectedItem(value);
		if (type === 'FILTER') {
			onResetClearValue(false);
			dispatch(setFilters({ ...commonfilters, fabricTypes: value }));
		} else {
			onSelectCallBack(value);
		}
	};

	return (
		<div className="form-group size36">
			{isUpdated && (
				<CommonDropdown
					itemLists={allFabricTypes}
					selectedItem={selectedItem}
					onSetSelectedItem={(value) => onSelectFabric(value)}
					title={'Category'}
				/>
			)}
		</div>
	);
};

export default FabricCategory;
